<template>
  <v-container fill-height fluid>
    <v-responsive align="center" justify="center">
      <v-img
        max-width="450"
        src="img/logo_negro_fondo_blanco_150.png"
        alt="apa"
        class="mb-4"
      />
      <v-card max-width="450" class v-if="!$store.getters.user">
        <v-card-title>
          <h1 class="title">Inicio de sesión</h1>
        </v-card-title>

        <v-card-text>
          <v-form ref="form">
            <v-text-field
              autocomplete="new-password"
              label="Número de Cédula"
              prepend-icon="mdi-account-circle"
              :rules="[rules.required]"
              v-model="username"
            ></v-text-field>
            <v-text-field
              autocomplete="new-password"
              label="Contraseña"
              :type="showPassword ? 'text' : 'password'"
              prepend-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              v-on:keyup.enter="login"
              v-model="password"
            ></v-text-field>
          </v-form>
          <span class="red--text" v-if="$store.getters.invalidPassword"
            >Usuario/contraseña invalido</span
          >
          <ResetPassword v-if="$store.getters.invalidPassword" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" outlined @click="$router.push('/singup')"
            >Registrarme</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="login">Iniciar sesion</v-btn>
        </v-card-actions>
      </v-card>
    </v-responsive>
  </v-container>
</template>

<script>
import axios from "axios";
import axiosauth from "../axios-auth";
import ResetPassword from "@/components/login/ResetPassword";
export default {
  data() {
    return {
      username: "",
      password: "123",
      showPassword: false,
      rules: {
        required: value => !!value || "Requerido.",
        counter: value => value.length <= 1000 || "Maximo 100 caracteres",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "correo electrónico invalido.";
        }
      }
    };
  },
  methods: {
    login() {
      if (this.$refs.form.validate()) {
        const authData = {
          username: this.username.toLowerCase(),
          password: this.password
        };
        this.$store.dispatch("login", authData);      
      }
    }
  },
  mounted() {
    if (this.$route.query.username) {
      this.username = this.$route.query.username;
    }
  },
  computed: {
    email() {
      return this.$store.getters.user.email;
    },
    stateUsername() {
      return this.$store.getters.username;
    }
  },
  components: {
    ResetPassword
  }
};
</script>
